import React, { useState, useRef } from "react";

const AudioPlayer = ({ url }) => {
  const [isPlaying, setIsPlaying] = useState(false); // State to toggle play/pause
  const audioRef = useRef(new Audio(url)); // Ref to manage the Audio object

  console.log("url", url);
  // Function to toggle play/pause
  const handlePlayPause = () => {
    if (!isPlaying) {
      audioRef.current.play(); // Play audio
      setIsPlaying(true);
    } else {
      audioRef.current.pause(); // Pause audio
      setIsPlaying(false);
    }
  };

  // Event listener for when audio ends
  audioRef.current.onended = () => {
    setIsPlaying(false); // Reset to play icon when audio ends
  };

  return (
    <img
      src={isPlaying ? "/icons/pause_record.png" : "/icons/play.png"} // Dynamic icon
      className="w-[24px] cursor-pointer"
      onClick={handlePlayPause} // Play/Pause logic
      alt="Play/Pause"
    />
  );
};

export default AudioPlayer;
